import {IListColumnProps} from '../../../../src/@interfaces/components/List/IListColumnProps';
import React, {useContext} from 'react';
import {renderOrderLogMessageRepresentation} from './messages';
import {ILogMessage} from '../../../../src/@interfaces/models/Order/LogMessages/ILogMessage';
import {NestedListFieldWidgetContext} from '../../../../src/components/Form/contexts/NestedListFieldWidgetContext';
import {IOrderLogModel} from '../../../../src/@interfaces/models/Order/IOrderLogModel';

function Fallback(props: { message: ILogMessage }) {
    return <div className="alert alert-danger">
        Message with type {props.message['@type']} not found
    </div>;
}

const emptyObject = {};

export function MessageColumn(props: IListColumnProps) {
    const context = useContext(NestedListFieldWidgetContext);
    const message = renderOrderLogMessageRepresentation(
            props.model as IOrderLogModel,
            context?.modelOptions ?? emptyObject,
    );

    return message ?? <Fallback message={props.model.message_details}/>;
}
